'use client';

import { MDSText } from '@midwest/web/base';
import { desktop } from '@thrivent/midwest-shared';
import styled from 'styled-components';

export const FullWidthFooterContainer = styled.footer`
  width: 100%;
  display: flex;
  background: linear-gradient(180deg, #f1d4a4 6.25rem, #fdfaf5 6.25rem);
`;

export const MaxWidthContainer = styled.div`
  max-width: 90rem;
  width: 100%;
  margin: 0 auto;
  padding-left: 2rem;
  padding-right: 2rem;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  height: 6.25rem;
`;

export const TitleText = styled(MDSText.Subtitle)`
  font-size: 1.25rem;
  font-weight: 400;
  color: ${(p) =>
    p.theme.midwestColors.componentButtonColorBackgroundStrongPrimaryDefault};
  ${desktop} {
    font-size: 1.625rem;
  }
`;

export const TrademarkText = styled(MDSText.BodyRegSm)`
  font-size: 0.5rem;
  font-weight: 400;
  margin-left: 0.25rem;
  ${desktop} {
    font-size: 0.625rem;
  }
`;

export const LinkColumnTitle = styled(MDSText.BodyHeavySm)`
  margin-bottom: 1rem;
  font-size: 1rem;
  font-weight: 700;
  color: ${(p) =>
    p.theme.midwestColors.componentButtonColorBackgroundStrongPrimaryDefault};
`;

export const LinksContainer = styled.div`
  padding-top: 1.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  border-bottom: none;
  margin-bottom: 1.5rem;
  ${desktop} {
    border-bottom: 1px solid #f9eedb;
  }
`;

export const LinksColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LinksColumnMobile = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const DisclosuresContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 2rem;
  margin-bottom: 2rem;
`;

export const DisclosureText = styled.p`
  padding-top: 1rem;
  font-size: 0.875rem;
  a {
    font-size: 0.875rem;
  }
`;

export const ExtraLinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  gap: 1.5rem;
  ${desktop} {
    gap: 0;
    flex-direction: row;
  }
`;
export const ResourceLinksContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  ${desktop} {
    gap: 1rem;
    justify-content: flex-start;
  }
`;

export const ResourceLinksColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  ${desktop} {
    flex-direction: row;
    gap: 1rem;
    white-space: nowrap;
    width: 100%;
  }
`;

export const SocialLinksContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  ${desktop} {
    flex-direction: row;
    justify-content: flex-end;
  }
`;

export const Disclosures = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const NavigationLink = styled.a`
  color: ${(p) =>
    p.theme.midwestColors.componentButtonColorBackgroundStrongPrimaryPressed};
  font-size: 0.875rem;
  font-weight: 400;
  margin-bottom: 0.5rem;
`;

export const NavigationLinkButton = styled.button`
  color: ${(p) =>
    p.theme.midwestColors.componentButtonColorBackgroundStrongPrimaryPressed};
  font-size: 0.875rem;
  font-weight: 400;
  margin-bottom: 0.625rem;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  padding: 0;
  align-items: center;
  justify-content: flex-start;
`;

export const ResourceLink = styled.a`
  color: ${(p) =>
    p.theme.midwestColors.componentButtonColorBackgroundStrongPrimaryPressed};
  font-size: 0.875rem;
  font-weight: 400;
  text-decoration: underline;
`;

export const ResourceLinkButton = styled.button`
  display: flex;
  padding: 0;
  align-items: center;
  justify-content: flex-start;
  color: ${(p) =>
    p.theme.midwestColors.componentButtonColorBackgroundStrongPrimaryPressed};
  font-size: 0.875rem;
  font-weight: 400;
  text-decoration: underline;
  background: none;
  border: none;
  cursor: pointer;
`;

export const SocialLinkContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  height: 2rem;
  width: 2rem;
  background-color: #f9eedb;
`;

export const SocialLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
`;
